export default __webpack_public_path__ + "static/media/480_store03-it-mobile.e2388f30.png";